module.exports = __webpack_public_path__ + "83c1ec1f1db9a6416791f7d9d29536f2.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/public/fonts/Montserrat/Montserrat-SemiBoldItalic.ttf
// module id = 1807
// module chunks = 1